export const defaultIDataTableRequest = () => {
    return {
        length: 20,
        orderColumn: 0,
        search: '',
        sortDirection: 'asc',
        start: 0
    };
};
